/**
 * 成交量state
 */
import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import {checkFootAuth, checkFootTitleAuth} from '../dectorator/checkauthdectorator/index.js';
import Util, {mergeModelData, numberFormat, TradVolume} from '../../util/index.js';
import {checkHKM} from '../../controller/util.js';
const model = {
  business_amount: {
    Type: Array,
    Default: () => ([])
  }
};
export default class TrendTurnoverState extends FootDectorator(BaseContext) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    const {business_amount, start, end} = this.state.data;
    this.calcRange({data: business_amount, targetKey: 'value', fixMinValue: 0, isAdditional: true});
  }
  _calcAxis() {
    const {business_amount} = this.state.data;
    this.calcAxis({data: business_amount, targetKey: 'value', sourceKey: 'barHeight', isAdditional: true});
  }
  _drawMain() {
    const {
      left,
      width,
      bottom
    } = this.availArea;
    const {business_amount} = this.state.data;
    this._drawBar(business_amount, left, bottom, width);
  }
  // @checkFootTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;
    const {top} = this.availArea;
    const {business_amount, current, sealObj, code} = this.state.data;
    const {height, baseSize} = this.state;
    const {baseLine} = this.option.FootContext.title;
    const baseLineY = top + height * baseLine;
    const {ratioFixed, perHand} = sealObj;
    const {colorMap} = this.option.BaseContext;
    let {left} = this.availArea;
    ctx2.textAlign = 'left';
    ctx2.textBaseline = 'top';
    const data = business_amount[current];
    const last_px = this.store.state.last_px[current];
    let text;
    if (Util.isDef(data)) {
      const {
        sizeRatio,
        fontFamily,
        color,
      } = this.option.Turnover;
      ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
      ctx2.fillStyle = color;
      const {value} = data;
      text = 'Volume: ' + TradVolume(value,code,perHand,2,last_px);
      ctx2.beginPath();
      ctx2.fillText(text, left, baseLineY);
      // ctx2.style()
    }
  }
}
